import React from 'react';
import { useNavigate } from 'react-router-dom';

const CategoryIcons = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 1,
      name: 'Birthday',
      image: '/images/ShopByCategory/birthday.webp',
      link: '/products?section=highlights-birthday'
    },
    {
      id: 2,
      name: 'Baby Shower',
      image: '/images/ShopByCategory/baby_shower_icon_e729406a-9ecb-4f08-989a-c85517b7d668.webp',
      link: '/products?section=highlights-baby-shower'
    },
    {
      id: 3,
      name: 'Anniversary',
      image: '/images/ShopByCategory/anniversary.webp',
      link: '/products?section=highlights-anniversary'
    },
    {
      id: 4,
      name: 'Festive Decor',
      image: '/images/ShopByCategory/festive.webp',
      link: '/products?section=featured'
    },
    {
      id: 5,
      name: 'Kids Activity',
      image: '/images/ShopByCategory/Activity.webp',
      link: '#'
    }
  ];

  const handleCategoryClick = (link) => {
    if (link !== '#') {
      navigate(link);
    }
  };

  return (
    <section className="py-4 sm:py-6 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex overflow-x-auto gap-3 sm:gap-4 pb-2 scrollbar-hide lg:justify-center lg:overflow-visible lg:gap-10 lg:w-full">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => handleCategoryClick(category.link)}
              className="flex-shrink-0 flex items-center justify-center hover:scale-105 transition-transform duration-300 group"
            >
              <div className="w-24 h-24 sm:w-36 sm:h-36 flex items-center justify-center">
                <img
                  src={category.image}
                  alt={category.name}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryIcons;

